module.exports = __webpack_public_path__ + "src/assets/images/icon-visualization-setstar.svg?f3f15068accadbc0069025528a6f9aa7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-visualization-setstar.svg
// module id = 148
// module chunks = 0